// app/javascript/controllers/offers_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["customerSelect", "locationSelect", "transactionSelect"]
    
    // Hier fangen wir die IDs aus der Datenbank ab
    static values = {
        selectedLocation: Number,
        selectedTransaction: Number
    }

    connect() {
        // Wenn beim Laden bereits ein Kunde ausgewählt ist (Edit-Modus)
        if (this.hasCustomerSelectTarget && this.customerSelectTarget.value) {
            this._fetchDependencies(this.customerSelectTarget.value, true)
        }
    }

    // Wird gefeuert, wenn der User den Kunden manuell im UI ändert
    loadDependencies(event) {
        const customerId = event.target.value
        if (!customerId) {
            this.clearSelect(this.locationSelectTarget)
            this.clearSelect(this.transactionSelectTarget)
            return
        }
        this._fetchDependencies(customerId, false)
    }

    // Interne Hilfsmethode für den AJAX-Request
    async _fetchDependencies(customerId, isInitialLoad) {
        try {
            const response = await fetch(`/customers/${customerId}/offer_dependencies`)
            const data = await response.json()

            // Dropdowns mit den neuen Optionen befüllen
            this.fillSelect(this.locationSelectTarget, data.locations, isInitialLoad ? this.selectedLocationValue : null)
            this.fillSelect(this.transactionSelectTarget, data.business_transactions, isInitialLoad ? this.selectedTransactionValue : null)
        } catch (error) {
            console.error("Fehler beim Laden der Kunden-Abhängigkeiten:", error)
        }
    }

    fillSelect(select, items, selectedId) {
        select.innerHTML = ""

        // Prompt/Placeholder wieder hinzufügen
        const promptOption = document.createElement("option")
        promptOption.value = ""
        promptOption.textContent = "Bitte wählen..."
        select.appendChild(promptOption)

        items.forEach(item => {
            const option = document.createElement("option")
            option.value = item.id
            option.textContent = item.name
            
            // Wenn die ID mit dem gespeicherten Wert übereinstimmt, selektieren!
            if (selectedId && Number(item.id) === Number(selectedId)) {
                option.selected = true
            }
            
            select.appendChild(option)
        })
    }

    clearSelect(select) {
        select.innerHTML = ""
        const option = document.createElement("option")
        option.value = ""
        option.textContent = "Bitte wählen..."
        select.appendChild(option)
    }
}